import { render, staticRenderFns } from "./Lckv-Camp.vue?vue&type=template&id=0b01e867&scoped=true&"
import script from "./Lckv-Camp.vue?vue&type=script&lang=js&"
export * from "./Lckv-Camp.vue?vue&type=script&lang=js&"
import style0 from "./Lckv-Camp.vue?vue&type=style&index=0&id=0b01e867&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b01e867",
  null
  
)

export default component.exports